const badgeDefaultState = {
  bg: 'inherit',
  text: 'inherit',
  border: 'inherit',
};

export { badgeDefaultState };
